import React, { JSX } from 'react';
import styles from './Header.module.css';

interface HeaderProps {
  size: 1 | 2 | 3 | 4 | 5;
  content: string | JSX.Element;
  className?: string;
}

export const Header: React.FC<HeaderProps> = ({ size, content, className }) => {
  const Tag = `h${size}` as keyof JSX.IntrinsicElements;

  return <Tag className={`${styles[`h${size}`]} ${className || ''}`}>{content}</Tag>;
};
